import React from "react";
import { Modal, Accordion } from "react-bootstrap";
import { Link, navigate } from "gatsby";

const MobileDropdown = (props) => {
  const redirectToSearch = (event, url) => {
    event.preventDefault();
    navigate(url);
  };

  const { allCategoryListHome, allRegionsHome, allTopManufacturer, Manufacturer } = props.data;

  return (
    <Modal
      className={"modal left-collapse fade modal-md mob-offcanvas-pannel-container"}
      show={props.showModal}
      onHide={props.toggleModal}
      id="categoriesCollapse"
      tabindex="-1"
      role="dialog"
    >
      <Modal.Header className="d-flex align-items-center">
        <h4>Browse By</h4>
        <div class="btn-close ms-auto" data-bs-dismiss="modal" onClick={props.toggleModal}></div>
      </Modal.Header>
      <Accordion className="modal-body">
        {allCategoryListHome && allCategoryListHome && allCategoryListHome.length > 0 && (
          <Accordion.Item eventKey="0">
            <Accordion.Button>Category</Accordion.Button>
            <Accordion.Body key={allCategoryListHome.length}>
              <div class="accor-body">
                <a
                target="_blank"
                  style={{
                    textDecoration: "underline",
                    color: "#47ad1d",
                    fontSize: "1rem",
                    padding: "0 0 12px 0",
                  }}
                  href={process.env.GATSBY_AVIATION_REDIRECT_URL+"all-categories"}
                >
                  View All Categories
                </a>
                {allCategoryListHome.map(
                  (v) =>
                    v.subCategories && (
                      <Accordion id="accorTwo">
                        <div className="accordion_item" eventKey={v.description}>
                          <Accordion.Button
                            onClick={(e) =>
                              v.description === "Pipe"
                                ? redirectToSearch(e, process.env.GATSBY_AVIATION_REDIRECT_URL+`pipe`)
                                : !v.subCategories.length
                                ? redirectToSearch(e, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/catid/${v.category_id}`)
                                : null
                            }
                          >
                            {v.description} {`(${v.auctions})`}
                          </Accordion.Button>
                          <Accordion.Body key={v.description}>
                            <div className="inner-accor-body">
                              <ul>
                                <li>
                                  <a
                                  target="_blank"
                                    style={{
                                      textDecoration: "underline",
                                      color: "#47ad1d",
                                    }}
                                    href={process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/catid/${v.category_id}`}
                                  >
                                    View All
                                    {` (${v.auctions})`}
                                  </a>
                                </li>
                                {v.subCategories.map((v1) => (
                                  <li>
                                    <a target="_blank" href={process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/catid/${v1.category_id}`}>
                                      {v1.description} {`(${v1.auctions})`}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Accordion.Body>
                        </div>
                      </Accordion>
                    ),
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {allRegionsHome && allRegionsHome.length > 0 && (
          <Accordion.Item eventKey="1">
            <Accordion.Button>Region</Accordion.Button>
            <Accordion.Body key={allRegionsHome.length}>
              <div className="accor-body">
                <a
                target="_blank"
                  style={{
                    textDecoration: "underline",
                    color: "#47ad1d",
                    fontSize: "1rem",
                    padding: "0 0 12px 0",
                  }}
                  href={process.env.GATSBY_AVIATION_REDIRECT_URL+"all-regions"}
                >
                  View All Regions
                </a>
                {allRegionsHome.map(
                  (v) =>
                    v.geoRegion === "North America" && (
                      <Accordion id="accorTwo">
                        <div className="accordion_item" eventKey={v.geoRegion}>
                          <Accordion.Button
                            onClick={(e) =>
                              !v.subRegion.length
                                ? redirectToSearch(e, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/georegionid/${v.geoRegionID}`)
                                : null
                            }
                          >
                            {"United States"} {`(${v.auctions})`}
                          </Accordion.Button>
                          <Accordion.Body key={v.description}>
                            <div className="inner-accor-body">
                              <ul>
                                <li>
                                  <a
                                    style={{
                                      textDecoration: "underline",
                                      color: "#47ad1d",
                                    }}
                                    href="javascript:void(0)"
                                    onClick={(event) =>
                                      redirectToSearch(event, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/regid/${v.geoRegionID}`)
                                    }
                                  >
                                    View All
                                    {` (${v.auctions})`}
                                  </a>
                                </li>
                                {v.subRegion.map((v1) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(event) =>
                                        redirectToSearch(event, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/regid/${v1.region_id}`)
                                      }
                                    >
                                      {v1.description} {`(${v1.auctions})`}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Accordion.Body>
                        </div>
                      </Accordion>
                    ),
                )}
                {allRegionsHome
                  .sort((a, b) => {
                    var textA = a.geoRegion.toUpperCase();
                    var textB = b.geoRegion.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                  })
                  .map((v) =>
                    v.subRegion && v.subRegion.length > 0 && v.geoRegion !== "North America" ? (
                      <Accordion id="accorTwo">
                        <div className="accordion_item" eventKey={v.geoRegion}>
                          <Accordion.Button
                            onClick={(e) =>
                              !v.subRegion.length
                                ? redirectToSearch(e, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/georegionid/${v.geoRegionID}`)
                                : null
                            }
                          >
                            {v.geoRegion} {`(${v.auctions})`}
                          </Accordion.Button>
                          <Accordion.Body key={v.description}>
                            <div className="inner-accor-body">
                              <ul>
                                <li>
                                  <a
                                    style={{
                                      textDecoration: "underline",
                                      color: "#47ad1d",
                                    }}
                                    href="javascript:void(0)"
                                    onClick={(event) =>
                                      redirectToSearch(event, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/regid/${v.geoRegionID}`)
                                    }
                                  >
                                    View All
                                    {` (${v.auctions})`}
                                  </a>
                                </li>
                                {v.subRegion.map((v1) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(event) =>
                                        redirectToSearch(event, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/regid/${v1.region_id}`)
                                      }
                                    >
                                      {v1.description} {`(${v1.auctions})`}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </Accordion.Body>
                        </div>
                      </Accordion>
                    ) : (
                      v.geoRegion !== "North America" && (
                        <p
                          class="para-item"
                          onClick={(e) =>
                            !v.subRegion.length
                              ? redirectToSearch(e, process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/georegionid/${v.geoRegionID}`)
                              : null
                          }
                        >
                          {v.geoRegion} {`(${v.auctions})`}
                        </p>
                      )
                    ),
                  )}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {allTopManufacturer && allTopManufacturer.length > 0 && (
          <Accordion.Item eventKey="2">
            <Accordion.Button>Manufacturer</Accordion.Button>
            <Accordion.Body>
              <Link
                style={{
                  textDecoration: "underline",
                  color: "#47ad1d",
                  fontSize: "1rem",
                  padding: "0 0 12px 0",
                }}
                to="/all-manufacturers"
              >
                View All Manufacturers
              </Link>
              <ul>
                {Manufacturer &&
                  Manufacturer.length > 0 &&
                  Manufacturer.map((et, i) => (
                    <li key={i}>
                      <a
                        href="javascript:void(0)"
                        onClick={(event) => {
                          event.preventDefault();
                          props.toggleModal(event);
                          if (et.description === "Pipe") {
                            navigate(process.env.GATSBY_AVIATION_REDIRECT_URL+`pipe`);
                          } else navigate(process.env.GATSBY_AVIATION_REDIRECT_URL+`listings/index.cfm/mfr/${et.mfrid}`);
                        }}
                      >
                        {et.description} ({et.auctions})
                      </a>
                    </li>
                  ))}
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
    </Modal>
  );
};

export default MobileDropdown;
